
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function Checkout() {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    postalCode: ''
  });

  const [cartItems] = useState([
    {
      id: 1,
      name: 'ساعة ذكية عصرية بتصميم أنيق',
      price: 599,
      quantity: 1,
      image: 'https://public.readdy.ai/ai/img_res/576a7fbf9adbaddf1a327e005e80c4c9.jpg'
    },
    {
      id: 2,
      name: 'سماعات لاسلكية بجودة صوت عالية',
      price: 299,
      quantity: 2,
      image: 'https://readdy.ai/api/search-image?query=premium%20wireless%20headphones%20with%20high%20quality%20sound%20on%20clean%20white%20minimalist%20background%2C%20modern%20audio%20device%20displayed%20professionally%2C%20high%20quality%20product%20photography%20with%20soft%20studio%20lighting%20and%20simple%20backdrop&width=200&height=200&seq=cart-002&orientation=squarish'
    }
  ]);

  const subtotal = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  const shipping = 50;
  const total = subtotal + shipping;

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    if (!formData.firstName || !formData.lastName || !formData.email || !formData.phone || !formData.address || !formData.city) {
      return;
    }
    
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      navigate('/order-success');
    }, 1500);
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#0D1B2A' }}>
      <Navbar />
      
      <div className="pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 text-white" style={{ fontFamily: "'Tajawal', sans-serif" }}>
              إتمام الطلب
            </h1>
            <p className="text-lg text-gray-400">
              أكمل معلومات الشحن لإتمام طلبك
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2">
              <div className="rounded-2xl shadow-md p-8 mb-8" style={{ backgroundColor: '#1B2D3E' }}>
                <h2 className="text-2xl font-bold mb-6 text-white" style={{ fontFamily: "'Tajawal', sans-serif" }}>
                  معلومات الشحن
                </h2>
                <form className="space-y-6">
                  <div className="grid md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-medium mb-2 text-white">
                        الاسم الأول
                      </label>
                      <input
                        type="text"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 rounded-lg text-sm focus:ring-2 focus:ring-[#D4A84B] focus:border-transparent text-white"
                        style={{ backgroundColor: '#0D1B2A', border: '1px solid #2D4356' }}
                        placeholder="أدخل الاسم الأول"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-2 text-white">
                        الاسم الأخير
                      </label>
                      <input
                        type="text"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 rounded-lg text-sm focus:ring-2 focus:ring-[#D4A84B] focus:border-transparent text-white"
                        style={{ backgroundColor: '#0D1B2A', border: '1px solid #2D4356' }}
                        placeholder="أدخل الاسم الأخير"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-2 text-white">
                      البريد الإلكتروني
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 rounded-lg text-sm focus:ring-2 focus:ring-[#D4A84B] focus:border-transparent text-white"
                      style={{ backgroundColor: '#0D1B2A', border: '1px solid #2D4356' }}
                      placeholder="example@email.com"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-2 text-white">
                      رقم الهاتف
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 rounded-lg text-sm focus:ring-2 focus:ring-[#D4A84B] focus:border-transparent text-white"
                      style={{ backgroundColor: '#0D1B2A', border: '1px solid #2D4356' }}
                      placeholder="+966 50 123 4567"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-2 text-white">
                      العنوان
                    </label>
                    <input
                      type="text"
                      name="address"
                      value={formData.address}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 rounded-lg text-sm focus:ring-2 focus:ring-[#D4A84B] focus:border-transparent text-white"
                      style={{ backgroundColor: '#0D1B2A', border: '1px solid #2D4356' }}
                      placeholder="الشارع، رقم المبنى"
                    />
                  </div>

                  <div className="grid md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-medium mb-2 text-white">
                        المدينة
                      </label>
                      <input
                        type="text"
                        name="city"
                        value={formData.city}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 rounded-lg text-sm focus:ring-2 focus:ring-[#D4A84B] focus:border-transparent text-white"
                        style={{ backgroundColor: '#0D1B2A', border: '1px solid #2D4356' }}
                        placeholder="المدينة"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-2 text-white">
                        الرمز البريدي
                      </label>
                      <input
                        type="text"
                        name="postalCode"
                        value={formData.postalCode}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 rounded-lg text-sm focus:ring-2 focus:ring-[#D4A84B] focus:border-transparent text-white"
                        style={{ backgroundColor: '#0D1B2A', border: '1px solid #2D4356' }}
                        placeholder="12345"
                      />
                    </div>
                  </div>
                </form>
              </div>

              <div className="rounded-2xl shadow-md p-8" style={{ backgroundColor: '#1B2D3E' }}>
                <h2 className="text-2xl font-bold mb-6 text-white" style={{ fontFamily: "'Tajawal', sans-serif" }}>
                  طريقة الدفع
                </h2>
                <div className="space-y-4">
                  <label className="flex items-center p-4 border-2 rounded-lg cursor-pointer hover:border-[#D4A84B] transition-colors" style={{ borderColor: '#2D4356', backgroundColor: '#0D1B2A' }}>
                    <input type="radio" name="payment" className="ml-3" defaultChecked style={{ accentColor: '#D4A84B' }} />
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 flex items-center justify-center">
                        <i className="ri-bank-card-line text-2xl text-white"></i>
                      </div>
                      <span className="font-medium text-white">بطاقة ائتمان</span>
                    </div>
                  </label>
                  <label className="flex items-center p-4 border-2 rounded-lg cursor-pointer hover:border-[#D4A84B] transition-colors" style={{ borderColor: '#2D4356', backgroundColor: '#0D1B2A' }}>
                    <input type="radio" name="payment" className="ml-3" style={{ accentColor: '#D4A84B' }} />
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 flex items-center justify-center">
                        <i className="ri-money-dollar-circle-line text-2xl text-white"></i>
                      </div>
                      <span className="font-medium text-white">الدفع عند الاستلام</span>
                    </div>
                  </label>
                </div>
              </div>
            </div>

            <div className="lg:col-span-1">
              <div className="rounded-2xl p-8 sticky top-32" style={{ backgroundColor: '#1B2D3E' }}>
                <h2 className="text-2xl font-bold mb-6 text-white" style={{ fontFamily: "'Tajawal', sans-serif" }}>
                  ملخص الطلب
                </h2>
                
                <div className="space-y-4 mb-6">
                  {cartItems.map((item) => (
                    <div key={item.id} className="flex items-center gap-4">
                      <div className="w-16 h-16 flex-shrink-0 rounded-lg overflow-hidden" style={{ backgroundColor: '#0D1B2A' }}>
                        <img 
                          src={item.image}
                          alt={item.name}
                          className="w-full h-full object-cover object-top"
                        />
                      </div>
                      <div className="flex-1 min-w-0">
                        <h3 className="text-sm font-medium line-clamp-2 text-white">
                          {item.name}
                        </h3>
                        <p className="text-sm text-gray-400">الكمية: {item.quantity}</p>
                      </div>
                      <div className="text-sm font-bold text-white">
                        {item.price * item.quantity} ر.س
                      </div>
                    </div>
                  ))}
                </div>

                <div className="pt-6 space-y-3" style={{ borderTop: '1px solid #2D4356' }}>
                  <div className="flex items-center justify-between text-gray-400">
                    <span>المجموع الفرعي</span>
                    <span className="font-medium">{subtotal} ر.س</span>
                  </div>
                  <div className="flex items-center justify-between text-gray-400">
                    <span>الشحن</span>
                    <span className="font-medium">{shipping} ر.س</span>
                  </div>
                  <div className="pt-3 flex items-center justify-between text-xl font-bold" style={{ borderTop: '1px solid #2D4356' }}>
                    <span className="text-white">المجموع الكلي</span>
                    <span style={{ color: '#D4A84B' }}>{total} ر.س</span>
                  </div>
                </div>

                <button 
                  onClick={handleSubmit}
                  disabled={isSubmitting}
                  className="w-full mt-8 px-6 py-4 text-black font-semibold rounded-lg transition-colors whitespace-nowrap cursor-pointer disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                  style={{ backgroundColor: '#D4A84B' }}
                  onMouseEnter={(e) => !isSubmitting && (e.currentTarget.style.backgroundColor = '#E5B95C')}
                  onMouseLeave={(e) => !isSubmitting && (e.currentTarget.style.backgroundColor = '#D4A84B')}
                >
                  {isSubmitting ? (
                    <>
                      <i className="ri-loader-4-line animate-spin text-xl"></i>
                      <span>جاري المعالجة...</span>
                    </>
                  ) : (
                    'تأكيد الطلب'
                  )}
                </button>

                <div className="mt-6 flex items-center justify-center gap-4 text-sm text-gray-400">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-shield-check-line text-lg"></i>
                  </div>
                  <span>دفع آمن ومشفر</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
